import React, { useEffect, useState } from 'react';
import AppBar from '@material-ui/core/AppBar';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { useLazyQuery } from 'app/hooks/useLazyQuery';
import { useDispatch, useSelector } from 'react-redux';
import { env } from 'env';
import UserAvatar from 'app/main/components/prefabs/UserAvatar/UserAvatar';
import { UserService } from 'app/services/userService';
import clsx from 'clsx';
import Logo from 'app/fuse-layouts/shared-components/Logo';
import { DarkenAvatar } from 'app/main/components/prefabs/DarkenAvatar';
import BrandLogo from 'app/main/components/logos/BrandLogo';
import * as UserActions from '../../auth/store/actions/user.actions';

const useStyles = makeStyles(theme => ({
  root: {
    '&.user': {
      '& .username, & .email': {
        transition: theme.transitions.create('opacity', {
          duration: theme.transitions.duration.shortest,
          easing: theme.transitions.easing.easeInOut
        })
      }
    },
    marginBottom: 70
  },
  logo: {
    marginBottom: 10
  },
  mediaUpload: {
    '& :hover': {
      '& button': {
        display: 'flex'
      }
    }
  },
  avatarContainer: {
    width: 72,
    height: 72,
    position: 'absolute',
    backgroundColor: 'rgb(247, 247, 247)',
    bottom: -43,
    padding: 8,
    boxSizing: 'content-box',
    borderRadius: '50%',
    left: '50%',
    transform: 'translateX(-50%)',
    transition: theme.transitions.create('all', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.easeInOut
    }),
    boxShadow:
      '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)'
  },
  large: {
    // background: theme.palette.background.default,
    width: theme.spacing(9),
    height: theme.spacing(9),
    color: `${theme.palette.common.white} !important`
  },
  iconButton: {
    display: 'none'
  },
  hidden: {
    display: 'none'
  },
  test: {
    color: theme.palette.text.dynamic
  },
  brandIcon: {
    color: theme.palette.text.dynamic,
    width: 135,
    height: 'inherit',
    marginBottom: theme.spacing(2)
  }
}));

function UserNavbarHeader(props) {
  const user = useSelector(({ auth }) => auth.user);
  const dispatch = useDispatch();
  const [getGroupById, { data: groupData }] = useLazyQuery('/groups');
  const [getBrandById, { data: brandData }] = useLazyQuery('/brands');
  const [avatarUrl, setAvatarUrl] = useState(user?.avatar);
  const classes = useStyles();

  useEffect(() => {
    dispatch(
      UserActions.setUserData({
        ...user,
        avatar: avatarUrl
      })
    );
  }, [avatarUrl]);

  useEffect(() => {
    if (user.group) {
      getGroupById({
        params: {
          id: user.group
        }
      });
    }

    if (user.brands) {
      getBrandById({
        params: {
          id: user.brands[0]
        }
      });
    }
  }, [user]);

  useEffect(() => {
    if (groupData) {
      if (groupData.name === 'Salon' && brandData) {
        setAvatarUrl(`brands/avatar/${brandData.code}.svg`);
      } else if (user.avatar) {
        if (/^users/.test(user.avatar)) {
          setAvatarUrl(user.avatar);
        } else {
          setAvatarUrl(`users/${user.avatar}`);
        }
      }
    }
  }, [groupData, brandData]);

  return (
    <AppBar
      position="static"
      elevation={UserService.isFranchise(user) ? 2 : 0}
      classes={{ root: classes.root }}
      className={clsx(
        'user relative flex flex-col items-center justify-center pt-24 pb-64 z-0',
        classes.test
      )}
    >
      <div className={`${classes.logo} logo-hidden`}>
        <BrandLogo
          className={classes.brandIcon}
          code={user?.hairdresserSelected?.brands?.code}
          size="large"
        />
      </div>
      {user.firstname && (
        <Typography className="username text-center text-16 " color="inherit">
          {(user.firstname ? user.firstname : user.username) +
            (user.lastname ? ` ${user.lastname}` : '')}
        </Typography>
      )}

      <Typography
        className="email text-13 text-center mt-8 opacity-50"
        color="inherit"
      >
        {user.email}
      </Typography>
      {groupData?.name === 'Salon' && (
        <div className={`${classes.avatarContainer} avatar-hidden`}>
          <DarkenAvatar className={classes.large}>
            {brandData?.code?.toUpperCase()}
          </DarkenAvatar>
        </div>
      )}
      {groupData && groupData.name !== 'Salon' && (
        <div className={`${classes.avatarContainer} avatar-hidden`}>
          {user.avatar ? (
            <DarkenAvatar
              className={clsx(classes.large)}
              alt="user photo"
              src={`${env.mediaUrl}/${user.avatar}`}
            />
          ) : (
            <UserAvatar
              className={clsx(classes.large)}
              firstname={user?.firstname}
              lastname={user?.lastname}
            />
          )}
        </div>
      )}
    </AppBar>
  );
}

export default UserNavbarHeader;
